import { designToken, quickProperty } from '../component-tokens';
export const borderBase = {
    'border-width': quickProperty('1px'),
    'border-style': quickProperty('solid'),
};
export const inputFieldBase = Object.assign(Object.assign({}, borderBase), { 'border-color': designToken('border-color-default'), color: designToken('type-color-default'), font: designToken('body-medium'), height: quickProperty('2.25rem'), 'border-radius': designToken('radius-small') });
export const inputFieldHoverBase = {
    'border-color': designToken('border-color-default'),
};
export const smallInputFieldBase = {
    font: designToken('body-small'),
    height: quickProperty('1.875rem'),
};
export const largeInputFieldBase = {
    height: quickProperty('2.625rem'),
};
export const xLargeInputFieldBase = {
    height: quickProperty('3rem'),
};
export const buttonBase = Object.assign(Object.assign({}, borderBase), { cursor: quickProperty('pointer'), 'box-sizing': quickProperty('border-box'), outline: quickProperty('none'), 'border-radius': designToken('radius-small'), 'white-space': quickProperty('normal') });
// TODO: we need to get rid of sooner or later the border color when we talk about focus state because it is causing some issues on the width and height in components
export const focusState = {
    'border-color': designToken('border-color-default'),
    'box-shadow': designToken('highlight'),
};
export const inputFieldFocusBase = Object.assign(Object.assign({}, focusState), { 'box-shadow': designToken('interactive-color-secondary-hover') });
export const primaryElementFocus = Object.assign({}, focusState);
export const secondaryElementFocus = Object.assign({}, focusState);
export const tertiaryElement = {
    color: designToken('type-color-brand-default'),
    'border-color': quickProperty('transparent'),
    'background-color': quickProperty('transparent'),
};
export const tertiaryNeutralElement = Object.assign(Object.assign({}, tertiaryElement), { color: designToken('type-color-default'), '--goto-icon-color': designToken('icon-color-default') });
export const tertiaryElementHover = {
    'border-color': quickProperty('transparent'),
    'background-color': designToken('interactive-color-secondary-hover'),
};
export const tertiaryElementFocus = Object.assign({}, primaryElementFocus);
export const tertiaryElementActive = {
    'border-color': quickProperty('transparent'),
    'background-color': designToken('interactive-color-secondary-pressed'),
    'box-shadow': quickProperty('none'),
};
